<script lang="ts">
import FirstViewCta from "../../components/sections/first-view-cta.svelte";
import { onMount } from "svelte";

let img: HTMLImageElement;

onMount(() => {
	if (window.innerWidth > 640) {
		img.src = "/first-view-woman-arm-pull.webp";
	}
});
</script>

<style>
  @media screen and (max-width: 639px) {
    .main-visual img {
      object-position: 0% 18%;
    }
  }
  @media screen and (min-width: 640px) {
    .main-visual img {
      object-position: 50% 20%;
    }
  }
</style>

<div>
  <div class="relative h-[400px] sm:h-[540px]">
    <div class="main-visual absolute w-full h-full">
      <img bind:this={img} src="/first-view-woman-arm-pull-600px.webp" alt="Balanced Body®ピラティスインストラクター養成講座" class="absolute w-full h-full object-cover" fetchpriority="high">
      <div class="bg-[#021AAB] opacity-60 w-full h-full" />
    </div>
    
    <div class="sm:w-[1132px] sm:mx-auto sm:relative sm:top-[140px] sm:flex sm:items-center sm:justify-between">
      <div class="text-white absolute top-20 left-0 right-0 px-6 sm:static sm:px-0">
        <h1 class="text-2xl font-bold tracking-wider leading-relaxed mb-6 sm:text-4xl sm:leading-relaxed">
          Balanced Body®<br>
          ピラティスインストラクター<br>
          養成講座
        </h1>
        
        <p class="text-lg tracking-wider leading-relaxed mb-6 sm:text-xl sm:leading-relaxed">
          世界に通用するピラティスインストラクターになりませんか<br>
          対面でもオンラインでも<br class="sm:hidden">資格が取得できます
        </p>
      </div>

      <div class="hidden sm:block bg-white static w-[458px] py-8 px-6 rounded-[20px]">
        <FirstViewCta />
      </div>
    </div>
  </div>
</div>